import logo from "../assets/res/logo_infinite.svg";
import searchIcon from "../assets/res/search.svg";

const PageHeader = ({ onSearchClick }) => (
  <div
    className="flex flex-row justify-between items-center px-4 py-3"
    style={{
      background: "linear-gradient(180deg, rgba(1,18,38,0.6) 0%, transparent 100%)",
    }}
  >
    <div className="flex flex-row items-center gap-2">
      <img src={logo} width="36" height="36" alt="Infinite Mod" />
      <h1
        className="pressStart text-xl tracking-wider"
        style={{
          background: "linear-gradient(135deg, #ffffff 0%, #89d4f5 60%, #468faf 100%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          backgroundClip: "text",
          filter: "drop-shadow(0 0 8px rgba(70,143,175,0.5))",
        }}
      >
        MOD
      </h1>
    </div>

    <div className="relative" onClick={onSearchClick}>
      <div
        className="absolute -inset-[1.5px] rounded-2xl opacity-90"
        style={{
          background: "linear-gradient(135deg, #f59e0b, #dc2626)",
          filter: "blur(3px)",
        }}
      />
      <div
        className="relative flex flex-row items-center gap-2 rounded-2xl px-4 py-2 cursor-pointer"
        style={{
          background: "#011226",
          border: "1px solid rgba(245,158,11,0.2)",
        }}
      >
        <img src={searchIcon} width="16" height="16" alt="Search" style={{ opacity: 0.85 }} />
        <span className="text-white semiBold text-sm">Search</span>
      </div>
    </div>
  </div>
);

export default PageHeader;
